import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
// Copies text to the clipboard using the modern Clipboard API, falling back to a
// hidden textarea + execCommand for browsers/contexts where it's unavailable.
// Never falls back to window.prompt, unlike the copy-to-clipboard package.
function copyTextToClipboard(_x) {
  return _copyTextToClipboard.apply(this, arguments);
}
function _copyTextToClipboard() {
  _copyTextToClipboard = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(text) {
    var textarea, success;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(typeof document === 'undefined')) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", false);
        case 2:
          if (!(typeof navigator !== 'undefined' && navigator.clipboard && typeof window !== 'undefined' && window.isSecureContext)) {
            _context.next = 11;
            break;
          }
          _context.prev = 3;
          _context.next = 6;
          return navigator.clipboard.writeText(text);
        case 6:
          return _context.abrupt("return", true);
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](3);
        case 11:
          textarea = document.createElement('textarea');
          textarea.value = text;
          textarea.setAttribute('readonly', '');
          textarea.style.position = 'fixed';
          textarea.style.top = '0';
          textarea.style.left = '0';
          textarea.style.opacity = '0';
          document.body.appendChild(textarea);
          textarea.focus();
          textarea.select();
          success = false;
          try {
            success = document.execCommand('copy');
          } catch (_unused2) {
            success = false;
          } finally {
            document.body.removeChild(textarea);
          }
          return _context.abrupt("return", success);
        case 24:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 9]]);
  }));
  return _copyTextToClipboard.apply(this, arguments);
}
export default copyTextToClipboard;